<template>
  <div
    class="
      flex
      flex-col
      h-full
      px-4
      w-full
    "
  >
    <div class="
      flex
      flex-col
      items-center
      justify-center
      w-full
    ">
      <form class="
        bg-white
        box-shadow
        flex
        flex-col
        items-center
        justify-center
        mt-[148px]
        px-6
        py-2
        rounded-lg
        w-[424px]
        sm:mb-7
        sm:mt-7
        sm:w-full
      ">
        <h1 class="mb-[72px] text-black font-light text-3xl sm:mb-7">
          重置密碼
        </h1>
        <div class="w-full mb-12 sm:mb-4">
          <w-input
            v-model="form.password"
            :message="getPasswordMsg"
            :show-error="hasErrorMsgs('password')"
            :show-success="
              !resetPwdValidator$.form.password.invalid && resetPwdValidator$.form.password.$dirty
            "
            class="w-full"
            password-reveal
            placeholder="設定密碼"
            type="password"
            @blur="resetPwdValidator$.form.password.$touch()"
          />
          <w-input
            v-model="form.confirmPassword"
            :message="getErrorMsgs('confirmPassword')"
            :show-error="hasErrorMsgs('confirmPassword')"
            :show-success="
              !resetPwdValidator$.form.confirmPassword.invalid
              && resetPwdValidator$.form.confirmPassword.$dirty
            "
            class="w-full"
            password-reveal
            placeholder="再次輸入密碼"
            type="password"
            @blur="resetPwdValidator$.form.confirmPassword.$touch()"
          />
        </div>
        <w-button
          :disabled="
            settingPassword || (resetPwdValidator$.form.$invalid && resetPwdValidator$.form.$dirty)
          "
          :loading="settingPassword"
          :variant="resetPwdValidator$.form.$invalid && !$breakpoints.sm ? 'outline' : null"
          class="mb-2 w-full"
          @click="confirm"
        >
          確定重置
        </w-button>
        <router-link class="text-primary-500 text-sm" replace to="/login">
          取消重置，前往登入頁面
        </router-link>
      </form>
    </div>
    <w-loading v-if="checkingToken" />
  </div>
</template>

<script>
import ResetPassword from './ResetPassword';

export default ResetPassword;
</script>

<style lang="scss" scoped>
@import 'ResetPassword';
</style>
